import { useMemo } from 'react';
import usePersonalSources from './usePersonalSources';
import { toWeeklySheet } from './personalAnalytics';

export const PERSONAL_SIM_NOTE = 'My portfolio and My strategies are yours only: built from your connected accounts (daily change in value, not counting deposits and withdrawals; weekend crypto P&L is counted on Friday) and your own CSV or webhook strategies, in dollars at 1×. For your analysis only, not a recommendation or guarantee.';

/**
 * The signed-in user's accounts ("My portfolio") and own strategies ("My
 * strategies") as Portfolio Simulator rows: weekly Mon–Fri sheets in dollars.
 */
export default function usePersonalSimData() {
  const src = usePersonalSources();
  const { sources, loading, error, reload } = src;
  const data = useMemo(() => {
    const used = new Set();
    const list = [];
    const rawDataMap = {};
    sources.forEach((s) => {
      let name = s.name;
      for (let n = 2; used.has(name.toLowerCase()); n += 1) name = `${s.name} (${n})`;
      used.add(name.toLowerCase());
      const rows = toWeeklySheet(s.points);
      if (rows.length <= 2) return;
      rawDataMap[name] = rows;
      list.push({ strategy: name, success: true, group: s.kind === 'account' ? 'portfolio' : 'mine' });
    });
    return { strategies: list, rawDataMap, loading, error: error || null, reload, note: PERSONAL_SIM_NOTE };
  }, [sources, loading, error, reload]);
  return { data, requiresPro: src.requiresPro, myStrategies: src.strategies, reload };
}
